import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ProjectStatus } from '@wilson/interfaces';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'wilson-project-status-tag',
  imports: [CommonModule, NzTagModule, TranslatePipe],
  template: `
    <nz-tag
      class="status-tag"
      [class.dashed-border]="status === ProjectStatus.OPEN"
      [nzColor]="
        status === ProjectStatus.FINISHED
          ? 'green'
          : status === ProjectStatus.ONGOING
            ? 'blue'
            : ''
      "
    >
      {{ 'project.status.' + (status | uppercase) | translate }}
    </nz-tag>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .status-tag {
        font-size: 0.75rem;
        padding: 2px 6px;
        height: auto;
        line-height: 1.2;
        border-radius: 2px;
      }
      .dashed-border {
        border-style: dashed;
      }
    `,
  ],
})
export class ProjectStatusTagComponent {
  @Input({ required: true }) status: ProjectStatus | undefined = undefined;
  ProjectStatus = ProjectStatus;
}
